import { CENTER, DOCUMENT } from "../constants/mainAPI";
import {
    DocumentCreate,
    DocumentSuccessResponse,
    DocumentsSuccessResponse,
    DocumentType,
} from "../types/api/documents";
import { ErrorResponseType } from "../types/api/main";
import { toFormData } from "../utils/toFormData";
import { doDeleteRequest, doGetRequest, doPostRequest } from "./mainAPI";

export const getDocuments = (
    centerId: string | undefined,
    searchParams?: { format?: DocumentType; tag_id?: number; limit?: number },
    callback?: (resp: DocumentsSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
): Promise<DocumentsSuccessResponse> => {
    return doGetRequest(
        `${CENTER}/${centerId || 0}/${DOCUMENT}`,
        true,
        searchParams,
        callback,
        errorCallback,
    ) as unknown as Promise<DocumentsSuccessResponse>;
};

export const createNewDocument = async (
    centerId: string | undefined,
    data: DocumentCreate,
    callback?: (resp: DocumentSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    return doPostRequest(`${CENTER}/${centerId || 0}/${DOCUMENT}`, true, formData, {}, callback, errorCallback);
};

export const deleteDocument = (
    centerId: string | undefined,
    documentId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}/${DOCUMENT}/${documentId}`, true, {}, callback, errorCallback);
};
